import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/mon-compte";
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [unverified, setUnverified] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    setUnverified(false);
    try {
      const u = await login(form.email, form.password);
      toast.success("Bienvenue ✿");
      navigate(u.role === "admin" ? "/admin" : next);
    } catch (err) {
      if (err.response?.status === 403) {
        setUnverified(true);
      } else {
        toast.error(err.response?.data?.detail || "Identifiants invalides");
      }
    } finally { setLoading(false); }
  };

  const resend = async () => {
    try {
      await api.post("/auth/resend-verification", { email: form.email });
      toast.success("E-mail de confirmation renvoyé ✿");
    } catch {
      toast.error("Impossible de renvoyer l'e-mail");
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <p className="overline text-berulia-rosedeep text-center">Espace client</p>
      <h1 className="font-heading text-5xl text-center mt-3">Bon retour <span className="font-serif-italic">parmi nous</span></h1>
      <form onSubmit={submit} className="mt-12 space-y-5">
        <label className="block"><span className="overline">Email</span>
          <input data-testid="login-email" required type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3 focus:border-berulia-ink outline-none"/></label>
        <label className="block"><span className="overline">Mot de passe</span>
          <input data-testid="login-password" required type="password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} className="mt-1 w-full bg-white border border-berulia-border px-3 py-3 focus:border-berulia-ink outline-none"/></label>
        <div className="text-right">
          <Link to="/mot-de-passe-oublie" data-testid="forgot-password-link" className="text-xs text-berulia-inkmuted hover:text-berulia-rosedeep link-underline">
            Mot de passe oublié ?
          </Link>
        </div>
        <button disabled={loading} data-testid="login-submit" className="w-full bg-berulia-rosedeep text-berulia-inkdeep overline py-4 hover:bg-berulia-rose transition">{loading?"…":"Se connecter →"}</button>
      </form>
      {unverified && (
        <div className="mt-6 bg-berulia-rose/20 border border-berulia-rose px-4 py-4 text-sm text-berulia-inkdeep">
          <p>Votre adresse e-mail n'est pas encore confirmée.</p>
          <button onClick={resend} className="mt-2 overline link-underline text-berulia-rosedeep">Renvoyer le lien de confirmation →</button>
        </div>
      )}
      <p className="text-center text-sm mt-6">Pas encore de compte ? <Link to="/inscription" className="link-underline overline">Créer un compte</Link></p>
    </div>
  );
}
